import { CurrentUser } from '../../types';
import { CurrentUserActions, CurrentUserActionType } from './CurrentUserActions';

export const initialCurrentUserState: CurrentUser = {
  aud: '',
  dealerId: '',
  storeCode: '',
  exp: 0,
  firstName: '',
  isPrimaryUser: false,
  iss: '',
  lastName: '',
  nbf: 0,
  permissionGrant: 1,
  userName: '',
  identityUserId: '',
  userId: '',
  duoKey: '',
  signed: '',
  permissions: [],
  currentDealType: '',
  showReleaseNotesNotification: false,
  isRooftopUser: false,
  isMultiStoreUser: false,
  isShadowLogin: '',
  shadowUserName: '',
  shadowUserFirstName: '',
  shadowUserLastName: '',
  jobTitle: '',
  intercomUserHMAC: '',
  shadowUserId: '',
};

export const currentUserReducer = (
  state: CurrentUser = initialCurrentUserState,
  action: CurrentUserActions,
): CurrentUser => {
  switch (action.type) {
    case CurrentUserActionType.SET_CURRENT_USER:
      return Object.assign({}, action.payload);

    case CurrentUserActionType.SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };

    case CurrentUserActionType.SET_CURRENT_DEALER:
      return {
        ...state,
        dealerId: action.payload,
      };

    case CurrentUserActionType.SET_CURRENT_DEAL_TYPE:
      return {
        ...state,
        currentDealType: action.payload,
      };

    case CurrentUserActionType.SET_CURRENT_STORE_CODE:
      return {
        ...state,
        storeCode: action.payload,
      };

    case CurrentUserActionType.SET_SHOW_RELEASE_NOTES:
      return {
        ...state,
        showReleaseNotesNotification: action.payload,
      };

    default:
      return state;
  }
};
